<template>
  <v-dialog
    :value="open"
    max-width="572"
    overlay-color="neutral lighten-1"
    overlay-opacity=".80"
    content-class="qr-dialog"
    scrollable
    @input="onDialogInput"
  >
    <v-card rounded class="pa-6">
      <v-card-title class="px-0 pt-0 pb-0">
        <p
          class="change-default-payment-method-dialog__title mb-0"
          data-test="change-default-payment-method-dialog-title"
        >
          {{ $t('fields.account.billing.payment.payment_methods_change_default_title') }}
        </p>
      </v-card-title>

      <v-card-text class="px-0 pt-3 pb-0" data-test="change-default-payment-method-dialog-message">
        <p class="change-default-payment-method-dialog__message mb-0">
          {{ $t('fields.account.billing.payment.payment_methods_change_default_message') }}
        </p>
      </v-card-text>

      <v-card-actions class="px-0 py-0 mt-6 justify-end">
        <v-btn
          outlined
          rounded
          :ripple="false"
          color="primary"
          large
          :disabled="isConfirming"
          data-test="change-default-payment-method-dialog-cancel"
          @click="cancel"
        >
          {{ $t('fields.account.billing.payment.payment_methods_cancel') }}
        </v-btn>
        <v-btn
          depressed
          rounded
          :ripple="false"
          large
          color="primary"
          class="change-default-payment-method-dialog__confirm-btn ml-4"
          :loading="isConfirming"
          :disabled="!method"
          data-test="change-default-payment-method-dialog-confirm"
          @click="confirm"
        >
          {{ $t('fields.account.billing.payment.payment_methods_set_default') }}
        </v-btn>
      </v-card-actions>

      <Dismiss absolute top right @click.stop="cancel" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import type { SavedPaymentMethod } from '@/classes/stripe';
import Dismiss from '@/components/Dismiss.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Dismiss,
  },
})
export default class ChangeDefaultPaymentMethodDialog extends Vue {
  @Prop(Boolean)
  open!: boolean;

  @Prop({ default: null })
  method!: SavedPaymentMethod | null;

  @Prop({ default: false })
  isConfirming!: boolean;

  onDialogInput(open: boolean): void {
    if (!open) {
      this.cancel();
    }
  }

  cancel(): void {
    if (this.isConfirming) {
      return;
    }
    this.$emit('cancel');
  }

  confirm(): void {
    if (!this.method || this.isConfirming) {
      return;
    }
    this.$emit('confirm', this.method);
  }
}
</script>

<style lang="scss" scoped>
.change-default-payment-method-dialog {
  &__title {
    font-size: rem(16);
    font-weight: 700;
    color: map-get($lapis, 'lighten-2');
    line-height: rem(22);
  }

  &__message {
    font-size: rem(14);
    color: map-get($neutral, 'darken-2');
    line-height: rem(20);
  }
}
</style>
